import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { UntypedFormControl, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
  selector: 'app-input-email',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: InputEmailComponent,
            multi: true
        }
    ],
  templateUrl: './input-email.component.html'
})
export class InputEmailComponent {

    @Input() id;
    @Input() placeholder;
    @Input() isDisabled = false;
    @Input() label;
    @Input() formControl: UntypedFormControl;
    @Input() showErrors = false;
    @Input() labelAlign = 'top';

    @Output() inputChange = new EventEmitter<any>();
    @Output() onBlurred = new EventEmitter<any>();

    get hasError() {
        return this.formControl && this.formControl.errors && this.showErrors;
    }

    @HostBinding('class.label-left') get leftAlignLabel() {
        return this.labelAlign === 'left';
    }

    private onChangeCallback: (_: any) => {};
    private onTouchedCallback: (_: any) => {};

    private _value = '';

    get value() {
        return this._value;
    }

    set value(value) {
        this._value = value;

        this.onChangeCallback(value);
        this.inputChange.emit(value);
    }

    writeValue(value) {
        this._value = value;
    }

    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }

    onBlur() {
        this.onBlurred.emit();
    }
}
